import axios, { AxiosResponse } from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_BASEURL,
});

api.defaults.withCredentials = true;
api.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";
api.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

import routes from "../utils/apiRoutes.json";

const onResponse = (response: AxiosResponse<any>, setAuthenticated: Function) => {
    const url = response.config.url;
    const status = response.request.status;
    if (url === routes.logout) {
        setAuthenticated(false);
    } else if (url === routes.login && status === 200) {
        setAuthenticated(true, response.data.id, true, true);
    }
    return response;
};

const onError = (error: any, setAuthenticated: Function) => {
    if (error.config.url === routes.logout)
        setAuthenticated(false);
    if (!error.response)
        return error;
    if (error.response.status === 401) {
        const originalRequest = error.config;
        let username: string | null;
        let password: string | null;
        username = localStorage.getItem("username");
        password = localStorage.getItem("password");
        if (!username)
            username = sessionStorage.getItem("username");
        if (!password)
            password = sessionStorage.getItem("password");
        if (!originalRequest._retry && username !== null && password !== null) {
            originalRequest._retry = true;
            return api.post(
                routes.login,
                {
                    username: username,
                    password: password,
                },
            ).then((response) => {
                if (response.status === 200)
                    setAuthenticated(true, response.data.id);
                else
                    setAuthenticated(false);
                return axios.request(originalRequest);
            },
            ).catch((err) => {
                setAuthenticated(false);
                return err;
            });
        } else
            setAuthenticated(false);
    }
    return error;
};

export const setAuthInterceptor = (setAuthenticated: Function): void => {
    api.interceptors.request.use(
        (request) => {
            if (!request.data) request.data = {};
            request.data.startTime = performance.now();
            return request;
        },
    );

    api.interceptors.response.use(
        (response) => {
            if (!(response.data instanceof Object))
                response.data = { data: response.data };
            response.data.responseTime = performance.now() - JSON.parse(response.config.data).startTime;
            return onResponse(response, setAuthenticated);
        },
        (error) => Promise.reject(onError(error, setAuthenticated)),
    );
};

export default api;
